@if (currentTenant$ | async) {
    <app-station-inbox />
} @else {
    <span class="color-gray12">
        Please select a tenant to display station inbox.
    </span>
}
